<template>
  <div>
    <q-dialog :visible="isVisible" :title="'店铺上架商品详情'" width="1100px" :innerScroll="false" :showFooter="false" :loading="loadingBtn" @close="onCancel">
      <div class="content">
        <!-- 商品信息区域 -->
        <div class="product-info">
          <div class="info-item">
            <span class="label">商品编码：</span>
            <span class="value">{{ rowData.skuCode }}</span>
          </div>
          <div class="info-item">
            <span class="label">商品名称：</span>
            <span class="value">{{ rowData.goodsName }}</span>
          </div>
          <div class="info-item">
            <span class="label">上市清单：</span>
            <span class="value">{{ rowData.name }}</span>
          </div>
        </div>

        <!-- 搜索区域 -->
        <search-box-dialog class="search-box">
          <el-form :inline="true" size="mini" :model="searchForm" :rules="rules" ref="searchForm">
            <el-form-item label="店铺名称" prop="storeCode">
              <el-select v-model="searchForm.storeCode" placeholder="全部" multiple collapse-tags clearable style="width: 240px">
                <el-option v-for="item in storeList" :key="item.storeCode" :label="item.storeName" :value="item.storeCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上架状态" prop="state">
              <el-select v-model="searchForm.state" placeholder="全部" multiple collapse-tags clearable style="width: 240px">
                <el-option v-for="item in listingStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
            <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
          </template>
        </search-box-dialog>

        <!-- 表格区域 -->
        <el-table
          ref="table"
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          :data="tableData.list"
          :height="360"
          class="full-width-table"
          border
        >
          <el-table-column label="店铺名称" prop="storeName" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column label="负责人" prop="userName" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column label="上架标记" prop="upType" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column label="上架状态" prop="state" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column label="商品发货周期" prop="sendCycle" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column label="原因" prop="reason" show-overflow-tooltip min-width="180"></el-table-column>
          <el-table-column label="操作人" prop="operUser" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column label="操作时间" prop="lastUpdateDate" show-overflow-tooltip width="160"></el-table-column>
        </el-table>

        <div class="pagination-container" height="auto">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page="tableData.pageNum"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </div>
      </div>
      <div class="footer-btn">
        <el-button size="mini" @click="onCancel">关闭</el-button>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import searchBoxDialog from '../../components/search-box.vue';
export default {
  name: 'GoodsStoreRecord',
  components: {
    searchBoxDialog,
  },
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  mounted() {
    if (this.rowData.state || this.rowData.state === 0) {
      this.$set(this.searchForm, 'state', [this.rowData.state]);
    }
    this.getStroeList();
    this.init();
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      rules: {},
      searchForm: {
        storeCode: [],
        state: [],
      },
      // 上架状态选项
      listingStatusOptions: [
        { label: '待上架', value: 0 },
        { label: '暂缓上架', value: 1 },
        { label: '无需上架', value: 2 },
        { label: '已上架', value: 3 },
      ],
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      storeList: [],
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    init() {
      this.loading = true;
      let data = {
        filterData: {
          ...this.searchForm,
          skuCode: this.rowData.skuCode,
          listNo: this.rowData.listNo,
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        productCode: this.rowData.productCode,
      };
      this.$q.newProduct
        .listGoodsDetail({ data: data })
        .then((res) => {
          this.tableData = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.tableData.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    getStroeList() {
      let data = {
        listNo: this.rowData.listNo,
        skuCode: this.rowData.skuCode,
      };
      this.$q.newProduct.querySkuStore({ data: data }).then((res) => {
        this.storeList = res.data
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.content {
  padding: 0 15px;
  max-height: 70vh;
  overflow-y: auto;
}

.product-info {
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.info-item {
  margin-right: 30px;
  margin-bottom: 10px;
}

.label {
  font-weight: bold;
  margin-right: 5px;
}

.search-box {
  margin-bottom: 15px;
}

>>> .date-range .single-date {
  width: 110px !important;
}

.full-width-table {
  width: 100%;
}

.pagination-container {
  text-align: right;
  padding: 15px 0;
}

.footer-btn {
  text-align: center;
  margin-top: 10px;
}

>>> .dialog-content {
  padding-right: 0 !important;
}

>>> .el-dialog {
  margin-top: 50px !important;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  height: 45.7326%;
  transform: translateY(0%);
  position: relative;
  display: block;
  cursor: pointer;
  border-radius: inherit;
  border-radius: 10px;
  background-color: rgba(144, 147, 153, 0.3);
  transition: 0.3s background-color;
}
</style>
